module.exports = __webpack_public_path__ + "static/media/cap.f561eff3.png";